/**
 * Enhanced CSV parser with date range detection
 */

export function parseCSV(csvText) {
  const lines = csvText.split('\n')
  const data = []

  // Skip header row (first line)
  for (let i = 1; i < lines.length; i++) {
    const line = lines[i].trim()
    if (!line) continue

    // Split by semicolon and remove quotes
    const columns = line.split(';').map(col => col.replace(/^"|"$/g, ''))

    // Check if we have enough columns
    if (columns.length < 14) continue

    const datetime = columns[10] // Column 11 (0-indexed)
    const energyType = columns[11] // Column 12
    const kwh = parseFloat(columns[13]) // Column 14

    // Validate data
    if (!datetime || !energyType || isNaN(kwh)) continue

    // Only process P+ and P- types
    if (energyType !== 'P+' && energyType !== 'P-') continue

    data.push({
      datetime: datetime,
      type: energyType,
      kwh: kwh
    })
  }

  return data
}

/**
 * Get date range from consumption data
 */
export function getDateRange(data) {
  if (!data || data.length === 0) {
    return { minDate: null, maxDate: null, daysDiff: 0 }
  }

  const dates = data.map(r => new Date(r.datetime))
  const minDate = new Date(Math.min(...dates))
  const maxDate = new Date(Math.max(...dates))
  const daysDiff = Math.ceil((maxDate - minDate) / (1000 * 60 * 60 * 24))

  return { minDate, maxDate, daysDiff }
}

/**
 * Group consumption data by hour
 */
export function groupByHour(data) {
  const grouped = {}

  data.forEach(record => {
    const date = new Date(record.datetime)
    const hour = date.getHours()
    const key = `${hour.toString().padStart(2, '0')}:00`

    if (!grouped[key]) {
      grouped[key] = { purchase: 0, sale: 0 }
    }

    if (record.type === 'P+') {
      grouped[key].purchase += record.kwh
    } else if (record.type === 'P-') {
      grouped[key].sale += record.kwh
    }
  })

  return grouped
}

/**
 * Group consumption data by date
 */
export function groupByDate(data) {
  const grouped = {}

  data.forEach(record => {
    const date = new Date(record.datetime)
    const dateKey = date.toISOString().split('T')[0]

    if (!grouped[dateKey]) {
      grouped[dateKey] = { purchase: 0, sale: 0 }
    }

    if (record.type === 'P+') {
      grouped[dateKey].purchase += record.kwh
    } else if (record.type === 'P-') {
      grouped[dateKey].sale += record.kwh
    }
  })

  return grouped
}

/**
 * Group consumption data by month
 */
export function groupByMonth(data) {
  const grouped = {}

  data.forEach(record => {
    const date = new Date(record.datetime)
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const monthKey = `${year}-${month}`

    if (!grouped[monthKey]) {
      grouped[monthKey] = { purchase: 0, sale: 0 }
    }

    if (record.type === 'P+') {
      grouped[monthKey].purchase += record.kwh
    } else if (record.type === 'P-') {
      grouped[monthKey].sale += record.kwh
    }
  })

  return grouped
}
